import React, { useState } from "react";
import classNames from "classnames/bind";

import styles from "./SearchInput.module.scss";

// assets
import { CloseIcon, LoaderIcon, SearchIcon } from "src/assets/icons";

// network
import { fetchSearchEvents } from "src/api/HomeApi";

const cx = classNames.bind(styles);
let timer = null;

const SearchInput = ({
  isClose,
  wrapperClass,
  handleDone,
  userLocation,
  handleClose,
}) => {
  const [isFlag, setIsFlag] = useState(false);
  const [value, setValue] = useState("");

  const handleKeyUp = (e) => {
    clearTimeout(timer);

    if (isFlag !== null) setIsFlag(false);
    timer = setTimeout(onDone, 500);
  };

  const handleKeyDown = (e) => {
    clearTimeout(timer);
    if (isFlag !== null) setIsFlag(false);
  };

  const onDone = async () => {
    if (value !== "") {
      setIsFlag(true);

      try {
        const response = await fetchSearchEvents(value, userLocation);
        handleDone(response.data.Results);
      } catch (err) {
        console.log(err);
        handleDone([]);
      }

      setIsFlag(false);
    } else {
      setIsFlag(false);
    }
  };

  const onClose = () => {
    setValue("");
    handleClose();
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div className={cx("search-input-root", wrapperClass)}>
      <SearchIcon />
      <input
        type="text"
        placeholder="Search anything"
        onKeyUp={handleKeyUp}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        value={value}
      />
      {isFlag && (
        <span className={cx("loader-wrapper")}>
          <LoaderIcon />
        </span>
      )}
      {isClose && !isFlag && <CloseIcon onClick={onClose} />}
    </div>
  );
};

export default SearchInput;
